<template>
  <ion-page>
    <main-header :back-href="defaultBackHref"></main-header>
    <ion-content>
      <form @submit.prevent="handleSubmit()" @keyup.enter="handleSubmit()">
        <ion-list lines="full">
          <input-box
            :validator="$v.email"
            :error-messages="{
              required: 'Please enter your email.',
              email: 'That email address doesn\'t appear to be valid.'
            }"
            :required="true"
            type="email"
            v-model="email"
          >
            Your Email
          </input-box>
          <ion-item v-if="emailAlreadyInUse" color="danger">
            That email is already in use.
            <ion-button
              fill="outline"
              color="light"
              size="small"
              class="ion-margin-start"
              @click="handleWantsToSignIn()"
            >
              Tap here to sign in
            </ion-button>
          </ion-item>

          <input-box
            :validator="$v.password"
            :error-messages="{
              required: 'Please choose a password.',
              minLength: 'Your password must be at least 8 characters.'
            }"
            :required="true"
            v-model="password"
            type="password"
          >
            Your Password
          </input-box>
        </ion-list>
        <div class="ion-padding">
          <submit-button :submitting="submitting">
            Get Started
          </submit-button>
        </div>
      </form>
    </ion-content>
  </ion-page>
</template>

<script>
import { required, email } from "vuelidate/lib/validators";
import passwordValidation from "@/validators/PasswordValidation";
import ErrorAlert from "@/ErrorAlert";
import { mapActions, mapGetters } from "vuex";
import submittable from "@/mixins/submittable";

export default {
  title: "Create Account",

  mixins: [submittable],

  data: function() {
    return {
      email: "",
      password: "",
      emailAlreadyInUse: false
    };
  },

  methods: {
    ...mapActions("auth", ["signUpWithEmail"]),

    async handleSubmit() {
      this.emailAlreadyInUse = false;

      this.$v.$touch();

      if (!this.$v.$invalid) {
        let loginResult = await this.signUpWithEmail({
          email: this.email,
          password: this.password
        });

        if (loginResult === false) {
          if (this.authError.code === "auth/email-already-in-use") {
            this.emailAlreadyInUse = true;
          } else {
            ErrorAlert(this.authError.message);
          }
        } else {
          this.$router.push("/");
        }
      }
    },

    handleWantsToSignIn() {
      this.$router.push({ name: "Sign In" });
    }
  },

  computed: {
    ...mapGetters("auth", ["authError"]),

    defaultBackHref() {
      return this.$router.resolve({
        name: "Sign Up"
      }).href;
    }
  },

  validations: {
    email: {
      required,
      email
    },
    password: passwordValidation
  }
};
</script>
